import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelope, 
  faClock,
  faPaperPlane,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faInstagram as faInstagramBrand } from '@fortawesome/free-brands-svg-icons';
import Card, { CardBody, CardIcon, CardTitle, CardDescription } from '../../components/Card';
import './contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Create WhatsApp message
    const message = `Halo iTech Service!

Nama: ${formData.name}
Email: ${formData.email}
Telepon: ${formData.phone}

Pesan: ${formData.message}`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=62895339559888&text=${encodeURIComponent(message)}`;
    
    setIsSubmitting(false);
    setIsSubmitted(true);
    
    // Open WhatsApp after a short delay
    setTimeout(() => {
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      setIsSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, 2000);
  };

  const contactInfo = [
    {
      id: 1,
      icon: faWhatsapp,
      title: 'WhatsApp',
      description: 'Chat cepat dan dukungan',
      details: '+62 895-3395-59888',
      action: () => window.open('https://api.whatsapp.com/send?phone=62895339559888', '_blank', 'noopener,noreferrer')
    },
    {
      id: 2,
      icon: faEnvelope,
      title: 'Email',
      description: 'Kirim pesan detail kepada kami',
      details: 'itechservice.id@gmail.com',
      action: () => window.open('mailto:itechservice.id@gmail.com', '_self')
    },
  ];

  return (
    <section className="contact section section--surface" id="contact">
      <div className="container">
        {/* Section Header */}
        <div className="contact__header" data-aos="fade-up">
          <h2 className="contact__title">Hubungi Kami</h2>
          <p className="contact__subtitle">
          Hubungi iTech Service untuk mendapatkan layanan servis perangkat Apple dengan penanganan yang cepat, aman, dan nyaman.
          </p>
        </div>

        <div className="contact__content">
          {/* Contact Form */}
          <div className="contact__form-section" data-aos="fade-up" data-aos-delay="200">
            <Card variant="contact" className="contact__form-card">
              <CardBody>
                <div className="contact__form-header">
                  <h3 className="contact__form-title">Kirim Pesan</h3>
                  <p className="contact__form-description">
                    Isi formulir di bawah ini dan kami akan menghubungi Anda secepatnya.
                  </p>
                </div>

                {isSubmitted ? (
                  <div className="contact__success">
                    <FontAwesomeIcon icon={faCheckCircle} className="contact__success-icon" />
                    <h4 className="contact__success-title">Pesan Terkirim!</h4>
                    <p className="contact__success-text">
                      Mengalihkan Anda ke WhatsApp untuk melengkapi pertanyaan...
                    </p>
                  </div>
                ) : (
                  <form className="contact__form" onSubmit={handleSubmit}>
                    <div className="contact__form-group">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Nama Anda"
                        required
                        className="contact__form-input"
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="contact__form-group">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Email Anda"
                        required
                        className="contact__form-input"
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="contact__form-group">
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="Nomor Telepon Anda"
                        required
                        className="contact__form-input"
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="contact__form-group">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Jelaskan masalah perangkat atau pertanyaan Anda..."
                        required
                        rows="5"
                        className="contact__form-textarea"
                        disabled={isSubmitting}
                      ></textarea>
                    </div>

                    <button 
                      type="submit" 
                      className="btn btn-primary contact__form-submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="contact__form-spinner"></span>
                          <span>Mengirim...</span>
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faPaperPlane} />
                          <span>Kirim Pesan</span>
                        </>
                      )}
                    </button>
                  </form>
                )}
              </CardBody>
            </Card>
          </div>

          {/* Contact Information */}
          <div className="contact__info-section">
            <h3 className="contact__info-title" data-aos="fade-up" data-aos-delay="300">
              Informasi Kontak
            </h3>
            
            <div className="contact__info-grid" data-aos="fade-up" data-aos-delay="400">
              {contactInfo.map((info, index) => (
                <Card 
                  key={info.id}
                  variant="contact-info"
                  interactive={true}
                  className="contact__info-card"
                  onClick={info.action}
                  data-aos="fade-up"
                  data-aos-delay={500 + (index * 100)}
                >
                  <CardIcon variant="contact" className="contact__info-icon">
                    <FontAwesomeIcon icon={info.icon} />
                  </CardIcon>
                  
                  <CardBody className="contact__info-content">
                    <CardTitle className="contact__info-card-title">
                      {info.title}
                    </CardTitle>
                    
                    <CardDescription className="contact__info-card-description">
                      {info.description}
                    </CardDescription>
                    
                    <div className="contact__info-details">
                      {info.details}
                    </div>
                  </CardBody>
                </Card>
              ))}
            </div>

            {/* Business Hours */}
            <Card 
              variant="contact-hours"
              className="contact__hours-card"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <CardBody>
                <div className="contact__hours-header">
                  <FontAwesomeIcon icon={faClock} className="contact__hours-icon" />
                  <h4 className="contact__hours-title">Jam Operasional</h4>
                </div>
                
                <div className="contact__hours-grid">
                  <div className="contact__hours-item">
                    <span className="contact__hours-day">Senin - Rabu</span>
                    <span className="contact__hours-time">10:00 - 21:00</span>
                  </div>
                  <div className="contact__hours-item">
                    <span className="contact__hours-day">Kamis</span>
                    <span className="contact__hours-time">Tutup</span>
                  </div>
                  <div className="contact__hours-item">
                    <span className="contact__hours-day">Jumat - Minggu</span>
                    <span className="contact__hours-time">10:00 - 21:00</span>
                  </div>
                </div>
              </CardBody>
            </Card>

            {false && (
  <div className="contact__social" data-aos="fade-up" data-aos-delay="900">
    <h4 className="contact__social-title">Ikuti Kami</h4>

    <div className="contact__social-links">
      <a 
        href="https://instagram.com/itechservice.id" 
        target="_blank" 
        rel="noopener noreferrer"
        className="contact__social-link"
        aria-label="Instagram iTech Service"
      >
        <FontAwesomeIcon icon={faInstagramBrand} />
      </a>

      <a 
        href="https://api.whatsapp.com/send?phone=62895339559888" 
        target="_blank" 
        rel="noopener noreferrer"
        className="contact__social-link"
        aria-label="WhatsApp iTech Service"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
    </div>
  </div>
)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
